var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title is-flex-shrink-1"},[_vm._v(" "+_vm._s(_vm.lang.message_modal_title)+" ")]),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){return _vm.$emit('close')}}})]),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"content is-large"},[_c('p',[_vm._v(_vm._s(_vm.lang.message_modal_description))]),_c('p',{staticClass:"has-text-right"},[_vm._v(" "+_vm._s(_vm.replaceDateText( _vm.lang.message_modal_url_expiration_date, ":date", _vm.getUrlExpiresTimestamp ))+" ")]),_c('blockquote',{class:_vm.$style.urlMessageArea,attrs:{"data-copy-contents":""},domProps:{"innerHTML":_vm._s(
            this.getReplacedText(
              _vm.lang.message_modal_text,
              {
                replaceKey: ':license_name',
                replacementCharacter: _vm.licenseName,
              },
              {
                replaceKey: ':name',
                replacementCharacter: _vm.getAdministratorName,
              },
              {
                replaceKey: ':date',
                timestamp: _vm.getUrlExpiresTimestamp,
              }
            )
          )}})])]),_c('footer',{staticClass:"modal-card-foot is-justify-content-flex-end"},[_c('button',{class:[
          [_vm.$style.copyButton],
          ( _obj = {}, _obj[_vm.$style.copyButton__tooltip] = _vm.isShowTooltip, _obj ),
          'button is-medium' ],attrs:{"data-tooltip":_vm.lang.message_modal_copy_complete},on:{"click":function($event){return _vm.onClickCopy()}}},[_vm._v(" "+_vm._s(_vm.lang.message_modal_copy)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }